import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../common/js/utils/apiHelper';

// initialize an empty api service that we'll inject endpoints into later as needed
export const adminxApi = createApi({
  reducerPath: 'adminxApi',
  baseQuery: baseQuery,
  endpoints: () => ({}),
});
